import React from 'react';
import { Tabs } from 'antd';

import SyntheticBondsV2 from '../SyntheticBondsV2';
import SyntheticBondCatalogue from './SyntheticBondCatalogue';

const SyntheticBondsTab: React.FC = () => (
  <Tabs
    defaultActiveKey="generate"
    items={[
      {
        key: 'generate',
        label: 'Generate',
        children: <SyntheticBondsV2 />,
      },
      {
        key: 'catalogue',
        label: 'See existing catalogue',
        children: <SyntheticBondCatalogue />,
      },
    ]}
  />
);

export default SyntheticBondsTab;
